import React from 'react';
import Form from '../../Shared/HubForm/Form';
import Section from '../Monzo/Section';
import { bitsList, inputs } from './data';
import './Styles/Container.scss';
import Tilt from 'react-parallax-tilt';
const Container=()=>{
    return(
        <div className="bits-container">
            <div className="content">
                <h1 data-aos="fade-right"
              data-aos-delay={100} >Our free eBook gives you a step-by-step guide and template pack to help start your first usability test</h1>
                <Section 
                title="The beginners guide to setting up UX testing"
                desc="This handy guide will help you run your first testing session, from creating your test plan, choosing a methodology - to recording and sharing results. We’ve also included templates for your planning and quick links to prototyping and testing in Hostdesign to make it even easier for you to get started."
                />
 <Tilt scale={0.9} transitionSpeed={3500}>

                <div className="image-part"></div>
                </Tilt>
                <h2>What's inside </h2>
                <ul>
                    {bitsList.map((item) =>{
                        return(
                            <li>{item}</li>
                        )
                    })}
                </ul>
            </div>
           
          <Form list={inputs}
          btn="Submit"
          />
          
        </div>
    )
};
export default Container ;